module.exports = __webpack_public_path__ + "static/media/login-container-bg.c036c044.png";